import { inviteConstants } from "../../../../NRP/constants/inviteConstant";
import authHeader from "../../../../services/auth/auth-header";
import { postApi, getApi } from "../../../../services/helpers/nrpApiCalls";
import { toast } from "react-toastify";
import moment from "moment";

let getListsCampaignData =
  (campaign, pageNumber, pageSize, searchValue, sortModel) => (dispatch) => {
    dispatch(request());

    let page = pageNumber + 1;
    let sorting = sortModel && sortModel[0];
    let val = searchValue.trim();

    let { campaignId } = campaign;

    let apiCallRequest = {
      url: `/mail/users/${campaignId}/${page}`,
      data: {
        sortBy: sorting.field !== null ? sorting.field : "email",
        sortDirection: sorting.sort !== null ? sorting.sort : "desc",
        searchQuery: val ? val : "",
        perpage: pageSize,
      },
      config: {
        headers: authHeader(),
      },
    };
    postApi(apiCallRequest)
      .then((res) => {
        let response = res.data;
        let listBoardData = response.rows;
        let totalUsers = response.total;
        let mainHeaders = [
          {
            headerName: "Email",
            field: "email",
            sort: "desc",
            headerAlign: "left",
            width: "210",
          },
          {
            headerName: "Invitation Sent Date",
            field: "createdAt",
            sort: "desc",
            headerAlign: "left",
            width: "210",
          },
          {
            headerName: "Expiry Date",
            field: "expired_at",
            sort: "desc",
            headerAlign: "left",
            width: "210",
          },
          {
            headerName: "Reminder",
            field: "reminder",
            sortable: false,
            headerAlign: "left",
            width: "150",
          },
          {
            headerName: "Reset",
            field: "reset",
            sortable: false,
            headerAlign: "left",
            width: "150",
          },
        ];

        let campaginData = {
          headerColumnNames: mainHeaders,
          listBoardData,
          totalUsers,
        };

        dispatch(success(campaginData));
      })
      .catch((err) => {
        dispatch(failure(err.message));
      });

    function request() {
      return {
        type: inviteConstants.INVITE_CAMPAGIN_DATA_REQUEST,
        payload: {
          isLoading: true,
        },
      };
    }

    function success(campaginData) {
      return {
        type: inviteConstants.INVITE_CAMPAGIN_DATA_SUCCESS,
        payload: {
          campaginData,
          isLoading: false,
        },
      };
    }
    function failure(error) {
      return {
        type: inviteConstants.INVITE_CAMPAGIN_DATA_FAILURE,
        payload: {
          error,
          isLoading: false,
        },
      };
    }
  };

let getCustomListEmails =
  (campaign, pageNumber, pageSize, customFilters) => (dispatch) => {
    let loadId = toast.loading("Please wait...", {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
    });
    let { campaignId, startDate, endDate } = campaign;
    let start = moment(startDate).format("YYYY-MM-DD");
    let end = moment(endDate).format("YYYY-MM-DD");
    let apiCallRequest = {
      url: `  `,
      data: {
        filters: {
          sortField: null,
          sortOrder: null,
          filtersParams: customFilters,
        },
      },
      config: {
        headers: authHeader(),
      },
    };

    postApi(apiCallRequest)
      .then(async (res) => {
        let response = res.data;
        let listBoardData = response.leaderBoard;
        let listEmails = [];
        for (let i = 0; i < listBoardData.length; i++) {
          const element = listBoardData[i];
          listEmails.push(element.email);
        }

        let page = 0;
        let count = listEmails.length - 1;

        async function loop(page) {
          // This would be the POST request
          let apiCallRequest = {
            url: `/mail/sendinvite/${campaignId}`,
            data: {
              email: listEmails[page],
            },
            config: {
              headers: authHeader(),
            },
          };

          let promise = new Promise((resolve, reject) => {
            postApi(apiCallRequest)
              .then((response) => {
                toast.update(loadId, {
                  render: `Invited ${page} out of ${count}`,
                  type: "default",
                  isLoading: false,
                  position: "bottom-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "dark",
                });

                if (response.status) {
                  resolve("done!");
                }
              })
              .catch((error) => {
                resolve("failed!");
                toast.update(loadId, {
                  render: "Failed to invite!",
                  type: "error",
                  isLoading: false,
                  position: "bottom-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "dark",
                });
              });
          });

          await promise;

          if (page < count) {
            await loop(page + 1);
          }
        }

        await loop(page);
        dispatch(success());

        function success() {
          return {
            type: inviteConstants.LIST_EMAILS_DATA_SUCCESS,
            payload: {
              isInviteDone: true,
            },
          };
        }
        toast.update(loadId, {
          render: `Invited Done!`,
          type: "success",
          isLoading: false,
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      })
      .catch((err) => {
        toast("Failed to invite!", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
          type: "error",
        });
      });
  };

// Get existing Tags

let listGetAllTags = (campaign) => (dispatch) => {
  let { campaignId } = campaign;
  let apiCallRequest = {
    url: `/tags/${campaignId}`,
    data: {},
    config: {
      headers: authHeader(),
    },
  };

  getApi(apiCallRequest)
    .then((res) => {
      let data = res.data.tags;
      let newArray = [];
      let topCanidates = {};
      for (let i = 0; i < data.length; i++) {
        const element = data[i];
        element.label = data[i].name;
        element.value = data[i].name;
        if (element.name === "Top Candidates") {
          topCanidates = element;
        } else {
          newArray.push(element);
        }
      }
      if (Object.keys(topCanidates).length > 0) {
        newArray.unshift(topCanidates);
      }
      dispatch(success(newArray));
    })
    .catch((err) => {
      dispatch(failure(err.message));
    });

  function success(data) {
    return {
      type: inviteConstants.INVITE_CAMPAIGN_TAGS_SUCCESS,
      payload: {
        tagsList: data,
      },
    };
  }
  function failure(error) {
    return {
      type: inviteConstants.INVITE_CAMPAIGN_TAGS_ERROR,
      payload: {
        error,
      },
    };
  }
};

let sendSingleInvite = (campaign, email) => (dispatch) => {
  let { campaignId } = campaign;
  let apiCallRequest = {
    url: `/mail/sendinvite/${campaignId}`,
    data: {
      email,
    },
    config: {
      headers: authHeader(),
    },
  };

  const id = toast.loading("Please wait...", {
    position: "bottom-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "dark",
  });

  postApi(apiCallRequest)
    .then((res) => {
      toast.update(id, {
        render: "Invite Sent",
        type: "success",
        isLoading: false,
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    })
    .catch((err) => {
      if (err.message === "Network Error") {
        toast.update(id, {
          render: "Network Error!",
          type: "error",
          isLoading: false,
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      } else {
        toast.update(id, {
          render: "Template Required!",
          type: "error",
          isLoading: false,
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }
    });
};

let resetInvite = (campaign, user) => (dispatch) => {
  let { email, date, message } = user;
  let { campaignId } = campaign;
  let apiCallRequest = {
    url: `/mail/sendreminder/${campaignId}`,
    data: {
      email,
      date,
      message,
    },
    config: {
      headers: authHeader(),
    },
  };

  const id = toast.loading("Please wait...", {
    position: "bottom-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "dark",
  });

  postApi(apiCallRequest)
    .then((res) => {
      toast.update(id, {
        render: "Reset Invite Done!",
        type: "success",
        isLoading: false,
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    })
    .catch((err) => {
      if (err.message === "Network Error") {
        toast.update(id, {
          render: "Network Error!",
          type: "error",
          isLoading: false,
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      } else {
        toast.update(id, {
          render: "Reset Failed!",
          type: "error",
          isLoading: false,
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }
    });
};

let sendReminder = (campaign, user) => (dispatch) => {
  let { email, date, message } = user;
  let { campaignId } = campaign;
  let apiCallRequest = {
    url: `/mail/sendreminder/${campaignId}`,
    data: {
      email,
      date,
      message,
    },
    config: {
      headers: authHeader(),
    },
  };

  const id = toast.loading("Please wait...", {
    position: "bottom-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "dark",
  });

  postApi(apiCallRequest)
    .then((res) => {
      toast.update(id, {
        render: "Reminder Sent!",
        type: "success",
        isLoading: false,
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    })
    .catch((err) => {
      if (err.message === "Network Error") {
        toast.update(id, {
          render: "Network Error!",
          type: "error",
          isLoading: false,
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      } else {
        toast.update(id, {
          render: "Reminder Failed!",
          type: "error",
          isLoading: false,
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }
    });
};

let saveTemplate = (campaign, settings) => (dispatch) => {
  let { emailTemplate, emailSubject, campaignEmail } = settings;
  let { campaignId } = campaign;
  let apiCallRequest = {
    url: `/campaigns/${campaignId}`,
    data: {
      campaignEmail,
      emailSubject,
      emailTemplate,
    },
    config: {
      headers: authHeader(),
    },
  };

  const id = toast.loading("Please wait...", {
    position: "bottom-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "dark",
  });

  postApi(apiCallRequest)
    .then((res) => {
      toast.update(id, {
        render: "Template Updated!",
        type: "success",
        isLoading: false,
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    })
    .catch((err) => {
      if (err.message === "Network Error") {
        toast.update(id, {
          render: "Network Error!",
          type: "error",
          isLoading: false,
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      } else {
        toast.update(id, {
          render: "Update Failed!",
          type: "error",
          isLoading: false,
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }
    });
};

// Unlock Game

let bulkInvites = (campaign, usersEmails) => async (dispatch) => {
  let page = 0;
  let count = usersEmails.length - 1;


  let { campaignId } = campaign;

  let loadId = toast.loading("Please wait...", {
    position: "bottom-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "dark",
  });
  async function loop(page) {
    // This would be the POST request
    let apiCallRequest = {
      url: `/mail/sendinvite/${campaignId}`,
      data: {
        email: usersEmails[page].name,
      },
      config: {
        headers: authHeader(),
      },
    };

    let promise = new Promise((resolve, reject) => {
      postApi(apiCallRequest)
        .then((response) => {
          toast.update(loadId, {
            render: `Invited ${page} out of ${count}`,
            type: "default",
            isLoading: false,
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });

          if (response.status) {
            resolve("done!");
          }
        })
        .catch((error) => {
          reject("failed!");
          toast.update(loadId, {
            render: "Failed to invite!",
            type: "error",
            isLoading: false,
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
        });
    });

    await promise;

    if (page < count) {
      await loop(page + 1);
    }
  }

  await loop(page);

  toast.update(loadId, {
    render: `Invited Done!`,
    type: "success",
    isLoading: false,
    position: "bottom-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "dark",
  });
};

export {
  getListsCampaignData,
  listGetAllTags,
  sendSingleInvite,
  resetInvite,
  sendReminder,
  saveTemplate,
  bulkInvites,
  getCustomListEmails,
};
